import request from '@/utils/axios'

/************  图层接口  ************/

//查询项目中执行者的图层
export function getLayer(params) {
  return request({
    url: '/layer/GetLayer',
    method: 'post',
    data: params
  })
}


//查询项目的图层
export function getLayerByProject(params) {
  return request({
    url: '/layer/GetLayerInfo',
    method: 'post',
    data: params
  })
}

// 根据项目编号和图层名查询图层
export function getLayerByIdAndName(params) {
  return request({
    url: '/Layer/GetBaseLayersByProjectUnitCode',
    method: 'get',
    params: params
  })
}


// 根据项目编号查询图层
export function getLayerByProjetcId(params) {
  return request({
    url: '/Layer/GetLayerByProjetcId',
    method: 'get',
    params: params
  })
}

// 根据图层名查询用户的图层信息
export function getLayerByName(params) {
  return request({
    url: '/layer/getLayerJurisdiction',
    method: 'get',
    params: params
  })
}

// 查询非任务图层
export function getNoTaskLayer(params) {
  return request({
    url: 'api/MapDoc/GetNoTaskLayer',
    method: 'get',
    params: params
  })
}

// 图层数据另存为
export function saveLayerData(params) {
  return request({
    url: '/layer/SaveLayerData',
    method: 'get',
    params: params
  })
}

// 向内网版导入图层信息（addin）
export function importLayer(params) {
  return request({
    url: '/layer/ImportLayer',
    method: 'get',
    params: params
  })
}

// 向内网版导入图层组、图层信息（addin）
export function importGroupLayers(params) {
  return request({
    url: '/layer/ImportGroupLayers',
    method: 'get',
    params: params
  })
}

//添加属性表到图层表
export function addAttributeTable(params) {
  return request({
    url: '/Layer/AddTable',
    method: 'post',
    data: params
  })
}


//更新属性信息
export function updateField(params) {
  return request({
    url: '/Project/UpdateTableLayer_Field',
    method: 'post',
    data: params
  })
}

//添加图层属性字段
export function addLayerField(params) {
  return request({
    url: 'api/MapDoc/AddLayer_Field',
    method: 'get',
    params: params
  })
}
//删除图层属性字段
export function deleteLayerField(params) {
  return request({
    url: 'api/GeoDataFeature/DeleteGData_Field',
    method: 'get',
    params: params
  })
}

//更新图层属性字段
export function updateLayerField(params) {
  return request({
    url: 'api/MapDoc/UpdateLayer_Field',
    method: 'get',
    params: params
  })
}

//获取图层字段
export function getLayerField(params) {
  return request({
    url: '/layer/GetLayerField',
    method: 'get',
    params: params
  })
}

//添加图层
export function addLayer(params) {
  return request({
    url: 'api/MapDoc/AddLayer',
    method: 'post',
    data: params
  })
}

//添加空间分析图层
export function addAnalysisLayer(params) {
  return request({
    url: '/layer/AddSpatialAnalysisLayer',
    method: 'get',
    params: params
  })
}

//更新底图图层
export function updateBaseLayer(params) {
  return request({
    url: 'api/MapDoc/UpdataBaseLayerinfo',
    method: 'get',
    params: params
  })
}

//删除图层 （项目编号以及图层名称）
export function delLayer(params) {
  return request({
    url: 'api/MapDoc/DeleLayerByProjectUnitCodeAndLayerName',
    method: 'post',
    data: params
  })
}
//批量删除图层 （项目编号以及图层名称）
export function batchDelLayer(params) {
  return request({
    url: '/api/MapDoc/DeleLayerList',
    method: 'post',
    data: params
  })
}

//设置为共享图层
export function SettingAsShareLayer(params) {
  return request({
    url: '/layer/SettingAsShareLayer',
    method: 'get',
    params: params
  })
}

//设置为非共享图层
export function settingAsNoShareLayer(params) {
  return request({
    url: '/layer/SettingAsNoShareLayer',
    method: 'get',
    params: params
  })
}

//删除图层组或影像
export function delLayerGroupOrImage(params) {
  return request({
    url: 'api/MapDoc/DeleLayerGroupOrImage',
    method: 'post',
    data: params
  })
}

//上传shape图层
export function uploadShpFile(params) {
  return request({
    url: '/layer/UploadShpFile',
    method: 'get',
    params: params
  })
}

//设置图层组（树形）是否展开
export function settingOpenState(params) {
  return request({
    url: 'api/MapDoc/SettingOpenState',
    method: 'post',
    data: params
  })
}

//设置标注
export function settingLabel(params) {
  return request({
    url: 'api/MapDoc/SettingLabel',
    method: 'post',
    data: params
  })
}

//设置标注是否可见
export function settingLabelVisible(params) {
  return request({
    url: 'api/MapDoc/SettingLabelVisible',
    method: 'post',
    data: params
  })
}

//添加图层组
export function addGroupLayer(params) {
  return request({
    url: 'api/MapDoc/AddGroupLayer',
    method: 'post',
    data: params
  })
}

//添加空间分析图层组
export function AddSpatialAnalysisGroup(params) {
  return request({
    url: '/layer/AddSpatialAnalysisGroup',
    method: 'get',
    params: params
  })
}


//更新图层名
export function updateLayerName(params) {
  return request({
    url: 'api/MapDoc/UpdateGroupName',
    method: 'post',
    data: params
  })
}

//更新图层符号化信息
export function updateLayerRenderer(params) {
  return request({
    url: 'api/MapDoc/UpadteLayer_Symbol',
    method: 'post',
    data: params
  })
}

//更新图层的渲染样式
export function updateSimpleRender(params) {
  return request({
    url: 'api/MapDoc/UpdateRenderSingleSymbol',
    method: 'post',
    data: params
  })
}



//更改图层顺序（序号）
export function changeLayerIndex(params) {
  return request({
    url: 'api/MapDoc/ChangeLayerIndex',
    method: 'post',
    data: params
  })
}
//添加底图图层
export function AddBaseLayer(params) {
  return request({
    url: '/SystemSettimg/AddBaseLayer',
    method: 'post',
    data: params
  })
}
//保存项目的模板信息
export function SaveTemplate(params) {
  return request({
    url: '/Layer/SaveTemplate',
    method: 'post',
    data: params
  })
}


export function getLayerInfoByName(params) {
  return request({
    url: 'api/MapDoc/SelectLayerByProjectUnitCodeAndLayerName',
    method: 'get',
    params: params
  })
}

export function upadteLayerBasic(params) {
  return request({
    url: 'api/MapDoc/UpadteLayer_Basic',
    method: 'post',
    data: params
  })
}
// 重设数据源
export function updateGroupData(params) {
  return request({
    url: 'api/MapDoc/UpdateGroupData',
    method: 'post',
    data: params
  })
}

export function getLayersByProjectUnitCode(params) {
  return request({
    url: '/AddinServer/GetLayersByProjectUnitCode',
    method: 'get',
    params: params
  })
}

export function getGDataField(params) {
  return request({
    url: 'api/MapDoc/GetGDataField',
    method: 'get',
    params: params
  })
}

//设置热力图
export function settingHeatMap(params) {
  return request({
    url: 'api/MapDoc/UpdateLayerHeatMap',
    method: 'post',
    data: params
  })
}

export function GetClassification(params) {
  return request({
    url: '/api/GData/GetClassification',
    method: 'get',
    params: params
  })
}
export function UpdateClassification(params) {
  return request({
    url: '/api/GData/UpdateClassification',
    method: 'post',
    data: params
  })
}
export function GetSectionList(params) {
  return request({
    url: '/api/GeoDataFeature/GetSectionList',
    method: 'get',
    params: params
  })
}
export function UpdateSection(params) {
  return request({
    url: '/api/GeoDataFeature/UpdateSection',
    method: 'post',
    data: params
  })
}
export function UpdateSectionState(params) {
  return request({
    url: '/api/GeoDataFeature/UpdateSectionState',
    method: 'get',
    params: params
  })
}
export function DeleteSection(params) {
  return request({
    url: '/api/GeoDataFeature/DeleteSection',
    method: 'get',
    params: params
  })
}
export function GetSectionState(params) {
  return request({
    url: '/api/GeoDataFeature/GetSectionState',
    method: 'get',
    params: params
  })
}
export function GetSectionDetailed(params) {
  return request({
    url: '/api/GeoDataFeature/GetSectionDetailed',
    method: 'get',
    params: params
  })
}

